import styled from 'styled-components';

export const StyledAIShowcase = styled.div`
  .ai-showcase {
    padding: 80px 24px;
    max-width: 1200px;
    margin: 0 auto;

    &__header {
      text-align: center;
      margin-bottom: 48px;

      h2 {
        margin-top: 8px;
        color: ${({ theme }) => theme.colors.black};
      }
    }

    &__header-description {
      max-width: 700px;
      margin: 16px auto 0;

      p {
        color: ${({ theme }) => theme.colors.raven};
        line-height: 1.6;
      }
    }

    &__features {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
    }

    &__feature {
      background-color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.iron};
      border-radius: 12px;
      padding: 28px;
      transition:
        transform 0.2s,
        box-shadow 0.2s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px ${({ theme }) => theme.colors.getTransparentColor(theme.colors.black, 0.08)};
      }
    }

    &__feature-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: linear-gradient(
        135deg,
        ${({ theme }) => theme.colors.mainBlue},
        ${({ theme }) => theme.colors.mariner}
      );
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;

      svg {
        color: ${({ theme }) => theme.colors.white};
        font-size: 1.25rem;
      }
    }

    &__feature-title {
      margin-bottom: 8px;
    }

    &__feature-description {
      p {
        color: ${({ theme }) => theme.colors.raven};
      }
    }

    @media (max-width: 900px) {
      &__features {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    @media (max-width: 600px) {
      padding: 48px 16px;

      &__features {
        grid-template-columns: 1fr;
      }
    }
  }
`;
